import { API_URL as ENDPOINT } from "../config/env";

/**
 * Lo que cuelga de una partida del presupuesto: sus fechas de pago y sus
 * aportaciones, cada una con el aportante que la puso.
 */

const cabeceras = (token) => ({
  "Content-Type": "application/json",
  "X-Requested-With": "XMLHttpRequest",
  Authorization: `${token}`,
});

export async function FechasPartidaGet(hijoId, token) {
  return fetch(`${ENDPOINT}FechasPartida/${hijoId}`, {
    headers: cabeceras(token),
  }).then((res) => res.json());
}

export async function FechaPartidaAdd(datos, token) {
  return fetch(`${ENDPOINT}FechaPartidaAdd`, {
    headers: cabeceras(token),
    method: "post",
    body: JSON.stringify(datos),
  }).then((res) => res.json());
}

export async function FechaPartidaDelete(id, token) {
  return fetch(`${ENDPOINT}FechaPartidaDelete`, {
    headers: cabeceras(token),
    method: "post",
    body: JSON.stringify({ id }),
  }).then((res) => res.json());
}

export async function AportacionesPartidaGet(hijoId, token) {
  return fetch(`${ENDPOINT}AportacionesPartida/${hijoId}`, {
    headers: cabeceras(token),
  }).then((res) => res.json());
}

export async function AportacionPartidaAdd(datos, token) {
  return fetch(`${ENDPOINT}AportacionPartidaAdd`, {
    headers: cabeceras(token),
    method: "post",
    body: JSON.stringify(datos),
  }).then((res) => res.json());
}

export async function AportacionPartidaDelete(id, token) {
  return fetch(`${ENDPOINT}AportacionPartidaDelete`, {
    headers: cabeceras(token),
    method: "post",
    body: JSON.stringify({ id }),
  }).then((res) => res.json());
}
